import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/house-id-logo.svg'
import _imports_1 from '@/assets/icons/house-id-logo2.svg'
import _imports_2 from '@/assets/images/Minbostad.png'
import _imports_3 from '@/assets/images/Boendeekonomi.png'
import _imports_4 from '@/assets/images/Braattgora.png'
import _imports_5 from '@/assets/icons/Google_Play_logo.png'
import _imports_6 from '@/assets/icons/Appstore_logo.png'
import _imports_7 from '@/assets/images/QR-kodOrdnabolån.svg'


const _withScopeId = n => (_pushScopeId("data-v-10b5a96c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div style=\"height:80px;\" class=\"row border-top border-bottom align-items-center\" data-v-10b5a96c><div class=\"col text-center\" data-v-10b5a96c><span data-v-10b5a96c><img src=\"" + _imports_0 + "\" data-v-10b5a96c></span><span style=\"padding-left:10px;\" data-v-10b5a96c><img src=\"" + _imports_1 + "\" data-v-10b5a96c></span></div></div>", 1)
const _hoisted_2 = { class: "row align-items-center mt-n2" }
const _hoisted_3 = { class: "col my-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Ansvar, oro och utgifter, men också alldeles, alldeles underbart är det att äga, förvalta och utveckla sin bostad. House:ID hjälper bostadsägare att göra det enklare att äga, underhålla och utveckla bostaden så att ansvaret, oron och utgifterna blir mindre och allt blir mer underbart. ​ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Med automatik gör House:ID det enkelt att hämta all information om bostaden, dess produkter, ritningar, kvitton, uppdaterade värdeindikationer för bostaden, avtal och mycket mer. Du får påminnelser när avtal löper ut, när underhåll behövs, förenklar redovisning vid flytt mm. ​ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Verifiera dig som ägare med BankID för att logga på just din bostads ID. Lika enkelt blir det då att lämna över bostadens information när du säljer. ​ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "Appen som gör det enkelt att äga och ta hand om din bostad")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-bottom mt-3" }, null, -1))
const _hoisted_6 = { class: "my-4 text-center" }
const _hoisted_7 = { class: "row center" }
const _hoisted_8 = {
  key: 0,
  class: "col"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "col"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "col"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-bottom mt-3" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3 center" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Enkelt"),
      /*#__PURE__*/_createTextVNode(" - automatisk hämtning och smidig lagring av information")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Säkert"),
      /*#__PURE__*/_createTextVNode(" – bara du som ägare kan komma åt bostadens ID, via BankID")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Inga dolda avgifter"),
      /*#__PURE__*/_createTextVNode(" – kostnadsfritt för alla bostadsägare​")
    ])
  ])
], -1))
const _hoisted_19 = {
  key: 0,
  class: "row"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-center my-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
  ])
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "row"
}
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"col text-center my-2\" data-v-10b5a96c><span data-v-10b5a96c><a target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=se.houseid.app\" data-v-10b5a96c><img src=\"" + _imports_5 + "\" data-v-10b5a96c></a></span><span class=\"ms-2\" data-v-10b5a96c><a target=\"_blank\" href=\"https://apps.apple.com/se/app/house-id-acessa-ditt-hus-id/id1546758051\" data-v-10b5a96c><img src=\"" + _imports_6 + "\" data-v-10b5a96c></a></span></div>", 1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 2,
  class: "row mt-3 text-center"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, " Ladda ner appen idag! ")
], -1))
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.checkIfMobileDevice() || _ctx.checkIfMobileDevice())
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _hoisted_10))
              : _createCommentVNode("", true),
            (!_ctx.checkIfMobileDevice())
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_13))
              : _createCommentVNode("", true),
            (!_ctx.checkIfMobileDevice())
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_16))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_17,
        _hoisted_18,
        _createElementVNode("div", null, [
          (_ctx.checkIfMobileDevice())
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
            : _createCommentVNode("", true),
          (_ctx.checkIfMobileDevice())
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
            : _createCommentVNode("", true),
          (!_ctx.checkIfMobileDevice())
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}